<template>
  <v-row align="center" justify="center">

    <!-- Conteúdo — invertido: texto à esquerda, vídeo à direita -->
    <v-col cols="12" md="7" :order="2" :order-md="1">
      <SectionTitle>Veja como é o Gestor de Pedidos</SectionTitle>

      <p class="section-desc mt-4">
        Tudo que você precisa para não perder nenhum pedido — organizado, em tempo real e sincronizado com toda a sua equipe.
      </p>

      <div class="feature-list mt-7">
        <div v-for="(item, i) in features" :key="i" class="feature-item">
          <div class="feature-icon-wrap">
            <v-icon size="22" color="error">{{ item.icon }}</v-icon>
          </div>
          <div>
            <p class="feature-title">{{ item.title }}</p>
            <p class="feature-desc">{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </v-col>

    <!-- Vídeo vertical -->
    <v-col cols="12" md="5" :order="1" :order-md="2" class="d-flex justify-center">
      <div class="video-shell">
        <iframe
          src="https://www.youtube-nocookie.com/embed/OyjZsThFciA"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          title="Gestor de Pedidos"
          class="video-frame"
        />
      </div>
    </v-col>

  </v-row>
</template>

<script>
import SectionTitle from "@/components/SectionTitle.vue";

export default {
  name: 'GestorPedidosVideo',
  components: { SectionTitle },

  data: () => ({
    features: [
      {
        icon: 'mdi-view-dashboard-outline',
        title: 'Delivery, mesa e balcão em um só lugar',
        desc: 'Pedidos organizados, lançamento manual pelo PC, tablet ou celular — para você e seus atendentes.',
      },
      {
        icon: 'mdi-clock-fast',
        title: 'Tempo real com previsão de conclusão',
        desc: 'Acompanhe cada pedido ao vivo com o tempo estimado de entrega, relatórios completos e tudo sincronizado entre os atendentes.',
      },
      {
        icon: 'mdi-printer-pos-outline',
        title: 'Impressão automática e configurável',
        desc: 'Assim que o cliente envia o pedido, já sai na impressora — configure quantas vias, tamanho da letra e muito mais.',
      },
    ],
  }),
};
</script>

<style scoped lang="scss">
  /* Container do vídeo com sombra e borda */
  .video-shell {
    position: relative;
    border-radius: 24px;
    overflow: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
    width: 100%;
    max-width: 300px;

    @media (max-width: 600px) {
      max-width: 240px;
    }
  }

  .video-frame {
    display: block;
    width: 100%;
    aspect-ratio: 9 / 16;
    border: none;
  }

  /* Texto descritivo */
  .section-desc {
    font-size: 16px;
    line-height: 1.7;
    color: var(--text-secondary);
    margin: 0;
    max-width: 480px;
  }

  /* Lista de features */
  .feature-list {
    display: flex;
    flex-direction: column;
    gap: 22px;
  }

  .feature-item {
    display: flex;
    align-items: flex-start;
    gap: 16px;
  }

  .feature-icon-wrap {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: rgba(244, 6, 18, 0.1);
    border: 1px solid rgba(244, 6, 18, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .feature-title {
    font-size: 15px;
    font-weight: 700;
    margin: 0 0 4px;
    color: var(--text-primary);
  }

  .feature-desc {
    font-size: 14px;
    line-height: 1.55;
    color: var(--text-muted);
    margin: 0;
  }
</style>
